import { EXPERIMENTS } from '@app/config';
import useEdgeQuery from '@app/data/edge/hooks/useEdgeQuery';
import { useExperiment } from '@app/experiments';
import { GET_GEO_IP_LOCATION } from '../queries';
import { GeoLocation } from '../types/GeoLocation';

const useGeoIpLocation = () => {
  const isSegmentGeoIpLocationActive = useExperiment(
    EXPERIMENTS.segment_geo_location_web,
  );

  const { data } = useEdgeQuery<GeoLocation>(GET_GEO_IP_LOCATION, {
    enabled: isSegmentGeoIpLocationActive,
    select: (data) => data.geoIPLocation,
  });

  return data;
};

export default useGeoIpLocation;
